import { createTableColumn, DataGrid, DataGridBody, DataGridCell, DataGridHeader, DataGridHeaderCell, DataGridRow, OnSelectionChangeData, TableCellLayout, TableColumnDefinition } from "@fluentui/react-components";
import { AppsAddIn20Regular } from "@fluentui/react-icons";
import React from "react";
import { CadSystems } from "../IDB";

interface IAddonProps {
    onSelection: (selected: CadSystems[]) => void;
}

export const Addons = (props: IAddonProps) => {

    const addonOptions: Record<string, CadSystems> = {
        "NX Advanced MBD Adapter": "ADAPT_NX",
        "Creo Advanced MBD Adapter": "ADAPT_CRE",
        "Catia Advanced MBD Adapter": "ADAPT_CAT",
        "Inventor Advanced MBD Adapter": "ADAPT_INV",
        "Solidworks Advanced MBD Adapter": "ADAPT_SW",
        "Anark Software Development Kit (SDK)": "ADAPT_SDK"
    };

    const handleSelection = (e: React.MouseEvent<Element, MouseEvent>, data: OnSelectionChangeData) => {
        const keys: CadSystems[] = [];
        data.selectedItems.forEach((i: number) => {
            keys.push(Object.values(addonOptions)[i]);
        });
        props.onSelection(keys)
    };
    
    const columns: TableColumnDefinition<string>[] = [
        createTableColumn<string>({
            columnId: "name",
            renderHeaderCell: () => {
                return "Addon Name";
            },
            renderCell: (item) => {
                return (
                    <TableCellLayout media={<AppsAddIn20Regular/>}>
                        {item}
                    </TableCellLayout>
                );
            },
        })
    ];

    return (
        <DataGrid
            items={Object.keys(addonOptions)}
            columns={columns}
            selectionMode="multiselect"
            focusMode="composite"
            onSelectionChange={handleSelection}
        >
            <DataGridHeader>
                <DataGridRow
                    selectionCell={{
                        checkboxIndicator: { "aria-label": "Select all rows" },
                    }}
                >
                    {({ renderHeaderCell }) => (
                        <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                    )}
                </DataGridRow>
            </DataGridHeader>
            <DataGridBody<string>>
                {({ item, rowId }) => (
                    <DataGridRow<string>
                        key={rowId}
                        selectionCell={{
                            checkboxIndicator: { "aria-label": "Select row" },
                        }}
                    >
                        {({ renderCell }) => (
                            <DataGridCell>{renderCell(item)}</DataGridCell>
                        )}
                    </DataGridRow>
                )}
            </DataGridBody>
        </DataGrid>
    );
};